import { Link } from 'react-router-dom';

const products = [
  {
    id: 1,
    name: 'Tile Adhesive',
    icon: 'ri-grid-line',
    link: '/products/tile-adhesive',
    image: 'https://public.readdy.ai/ai/img_res/76eb1a751968f614b779e8668024ec26.jpg'
  },
  {
    id: 2,
    name: 'Grout',
    icon: 'ri-paint-brush-line',
    link: '/products/grout',
    image: 'https://readdy.ai/api/search-image?query=grout%20product%20container%20with%20rubber%20float%20application%20tool%20on%20clean%20white%20surface%2C%20premium%20quality%20tile%20grout%20for%20finishing%20ceramic%20installations%2C%20building%20supplies%20product%20photography%20with%20simple%20minimalist%20background&width=300&height=300&seq=product-grout-icon-002&orientation=squarish'
  },
  {
    id: 3,
    name: 'Paint & Coatings',
    icon: 'ri-paint-fill',
    link: '/products/paint',
    image: 'https://readdy.ai/api/search-image?query=paint%20can%20container%20with%20roller%20brush%20on%20clean%20white%20surface%2C%20professional%20quality%20paint%20and%20coating%20product%20for%20interior%20walls%2C%20building%20supplies%20product%20photography%20with%20simple%20minimalist%20background&width=300&height=300&seq=product-paint-icon-003&orientation=squarish'
  },
  {
    id: 4,
    name: 'Bonding Liquid',
    icon: 'ri-drop-line',
    link: '/products',
    image: 'https://readdy.ai/api/search-image?query=bonding%20liquid%20primer%20bottle%20with%20application%20brush%20on%20clean%20white%20surface%2C%20professional%20adhesion%20enhancer%20product%20for%20construction%20projects%2C%20building%20supplies%20product%20photography%20with%20simple%20minimalist%20background&width=300&height=300&seq=product-bonding-icon-004&orientation=squarish'
  }
];

export default function ProductsUsed() {
  const products = [
    {
      name: 'Tile Adhesive',
      icon: 'ri-grid-line',
      link: '/products/tile-adhesive',
      image: 'https://readdy.ai/api/search-image?query=Professional%20tile%20adhesive%20container%20product%20shot%20on%20clean%20white%20background%20building%20materials%20packaging%20with%20clear%20branding%20commercial%20product%20photography%20style&width=300&height=300&seq=product-tile-adhesive-learn&orientation=squarish'
    },
    {
      name: 'Grout',
      icon: 'ri-paint-brush-line',
      link: '/products/grout',
      image: 'https://readdy.ai/api/search-image?query=Professional%20grout%20container%20product%20shot%20on%20clean%20white%20background%20building%20materials%20packaging%20with%20clear%20branding%20commercial%20product%20photography%20style&width=300&height=300&seq=product-grout-learn&orientation=squarish'
    },
    {
      name: 'Paint & Coatings',
      icon: 'ri-paint-line',
      link: '/products/paint',
      image: 'https://readdy.ai/api/search-image?query=Professional%20paint%20can%20product%20shot%20on%20clean%20white%20background%20building%20materials%20packaging%20with%20clear%20branding%20commercial%20product%20photography%20style&width=300&height=300&seq=product-paint-learn&orientation=squarish'
    },
    {
      name: 'Bonding Liquid',
      icon: 'ri-drop-line',
      link: '/products',
      image: 'https://readdy.ai/api/search-image?query=Professional%20bonding%20liquid%20container%20product%20shot%20on%20clean%20white%20background%20building%20materials%20packaging%20with%20clear%20branding%20commercial%20product%20photography%20style&width=300&height=300&seq=product-bonding-learn&orientation=squarish'
    }
  ];

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Products Featured in Our Guides
          </h2>
          <p className="text-lg text-gray-600">
            The same professional-grade materials used in our tutorials
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {products.map((product, index) => (
            <a 
              key={index}
              href={product.link}
              className="group bg-gray-50 rounded-lg p-6 hover:shadow-md transition-all cursor-pointer"
            >
              <div className="w-full h-48 mb-4 rounded-lg overflow-hidden bg-white">
                <img 
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform"
                />
              </div>
              <h3 className="text-xl font-bold text-center" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {product.name}
              </h3>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}